export default __webpack_public_path__ + "static/media/Kid2.21cc098e.jpg";